module.exports = __webpack_public_path__ + "static/media/bg_default.20ef8b10.jpg";